var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCloseComment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "#FFF7F2",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.95519 15.9963C8.7112 15.9963 8.46722 15.9036 8.28169 15.7168C7.90936 15.3446 7.90936 14.7424 8.28169 14.3701L14.3711 8.28188C14.7434 7.90962 15.3458 7.90962 15.7181 8.28188C16.0904 8.65413 16.0904 9.25635 15.7181 9.6286L9.62868 15.7168C9.44315 15.9036 9.19917 15.9963 8.95519 15.9963Z",
    fill: "#E82020"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0473 16C14.8033 16 14.5593 15.9073 14.3738 15.7205L8.27925 9.62592C7.90692 9.25366 7.90692 8.65145 8.27925 8.27919C8.65285 7.90694 9.25518 7.90694 9.62624 8.27919L15.7208 14.3738C16.0931 14.746 16.0931 15.3482 15.7208 15.7205C15.5352 15.9073 15.29 16 15.0473 16Z",
    fill: "#E82020"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCloseComment);
export default __webpack_public_path__ + "static/media/iconCloseComment.e48dc4c666de5e1898a3f83f4fd176b6.svg";
export { ForwardRef as ReactComponent };